// Utilities
import axios from 'axios';

const state = {
  obj: 'working',
  new_document_object: {},
  error: '',

  margin: null,
};

const mutations = {
  SET_NEW_DOCUMENT(state, payload) {
    state.new_document_object = payload;
  },
  Auth_error(state, payload) {
    state.error = "Ce numéro de document n'existe pas";
  },
};

const actions = {
  getJobOffer({ commit }, Infos) {
    const datacollect = {
      page: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/F893JG03VLKJ09C24V25/getJobOffer',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteJobOffer({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/F893JG03VLKJ09C24V25/deleteJobOffer',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchJobOffer({ commit }, Infos) {
    const datacollect = {
      page: Infos.page,
      searchData: Infos.searchData,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/F893JG03VLKJ09C24V25/searchJobOffer',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
